import * as React from 'react';
import './_comments-header.scss';
import { ICommentsHeaderProps } from './types';
import { CLASS_COMMENTS_SECTION, CLASS_COMMENTS_SECTION_TITLE } from '../../constants';
import { Button, ButtonTitle, Icon } from 'kui';
import { COMMENTS_CHAT_TOOLTIP_JOIN, COMMENTS_CHAT_TOOLTIP_LEAVE, COMMENTS_ORDER_LABEL } from './constants';
import { EUserSettingsCommentSort } from '../../../../../../../types/rest/IRestAuthUser';

export function CommentsHeader({
    isChat,
    isShowChat,
    order,
    onToggleOrder,
    onToggleChat,
}: ICommentsHeaderProps) {
    const isAsc = order === EUserSettingsCommentSort.ASC;

    const wrapperName = CLASS_COMMENTS_SECTION + '__header';
    const titleClass = CLASS_COMMENTS_SECTION_TITLE;
    const titleTextClass = CLASS_COMMENTS_SECTION + '__label';
    const sorterClass = CLASS_COMMENTS_SECTION + '__sorter';
    const classButton = wrapperName + '-button';

    const sorterClassAsc = isAsc ? sorterClass + '--asc' : '';
    const sorterIconClass = CLASS_COMMENTS_SECTION + '__sorter-icon';
    const sorterTitleClass = CLASS_COMMENTS_SECTION + '__sorter-title';

    const orderText = isAsc
        ? COMMENTS_ORDER_LABEL.ASC
        : COMMENTS_ORDER_LABEL.DESC;

    const ChatIcon = require(`!!@svgr/webpack!./chat.svg`).default;

    return (
        <div className={wrapperName}>
            <div className={titleClass}>
                <span
                    className={titleTextClass}
                >
                    Comments
                </span>
            </div>
            <div className={wrapperName + '-actions'}>
                {!!order &&
                    <Button
                        className={`
                            ${sorterClass}
                            ${sorterClassAsc}
                        `}
                        variant={'icon-text'}
                        onClick={onToggleOrder}
                    >
                        <Icon
                            className={sorterIconClass}
                            xlink={'arrow-s-drop-close'}
                            size={24}
                        />
                        <ButtonTitle
                            className={sorterTitleClass}
                        >
                            {orderText}
                        </ButtonTitle>
                    </Button>
                }
                {isShowChat &&
                    <Button
                        className={`
                        ${classButton}
                        ${isChat ? classButton + '--active' : ''}
                    `}
                        variant={'icon'}
                        onClick={onToggleChat}
                        tooltip={isChat ? COMMENTS_CHAT_TOOLTIP_LEAVE : COMMENTS_CHAT_TOOLTIP_JOIN}
                    >
                        <ChatIcon />
                    </Button>
                }
            </div>
        </div>
    );
}
